import config from "../config";

export const CONSTANTS = {
  HOST: '',
  UTYPE_CLIENT: 1,
  UTYPE_CUSTOMER: 2,
  UTYPE_ADMIN: 4,
  SESSION_USER: 'SESSION_USER',
  MENU: 'MENU',
  PANES: 'PANES',
  MINI_SIDE_NAV: 'MINI_SIDE_NAV',
  X_APP_HEADER: 'x-app-header',
  VISITOR_ID: 'visitor-id',
  DATE_MASK: 'YYYY-MM-DD',
  TOAST_TIMEOUT: 2500,
  DISPLAY_DATE_FORMAT: 'MM/DD/YYYY',
  ENVIRONMENT: config.ENVIRONMENT,
  RECURRENCE_TYPES: {
    RECURRENCES_WEEKLY: 'WEEKLY',
    RECURRENCES_MONTHLY: 'MONTHLY',
    RECURRENCES_ANNUALLY: 'ANNUALLY',
    TIME_BASED: 'TIME_BASED',
    TIME_BASED_RECURRING: 'TIME_BASED_RECURRING',
  },
  DISPLAY_ENVIRONMENT: (config.ENVIRONMENT === 'Production' ? '' : config.ENVIRONMENT),
  ENTITY_TYPE: {
    CUSTOMER: 1,
    INVENTORY: 2
  },
  CALENDAR_TOOLBAR: {
    left: 'prev,next',
    center: 'title',
    right: 'timeGridDay,dayGridWeek,dayGridMonth' // user can switch between the two
  },
  REGISTER_CONTEXT_TYPE: [
    {
      id: 1,
      name: 'Shift Start'
    },
    {
      id: 2,
      name: 'Shift End'
    },
    {
      id: 3,
      name: 'Reconciliation'
    },
  ],
  PERK_FREQUENCY_TYPES: [
    {
      id: 1,
      name: 'Day'
    },
    {
      id: 2,
      name: 'Week'
    },
    {
      id: 3,
      name: 'Month'
    }
  ],
  EXT_APPLICATION: {
    SQUARE: 1,
    STRIPE: 2
  },
  EXT_CREDENTIAL: {
    EMAIL: 1,
    SMS: 2,
  },
  USER_TYPE: {
    NONE: -1,
    EMPLOYEE: 1,
    CUSTOMER: 2,
    FAMILY: 3,
    ADMIN: 4
  },
  USER_STATUS: {
    NONE: -1,
    ACTIVE: 1,
    INACTIVE: 2,
    PENDING: 3,
    DELETED: 4
  },
  CHARGE_TYPE: {
    CARD: 1,
    CASH: 2,
    GIFT_CARD: 3,
    UNSPECIFIED: 4,
    INVOICE: 5,
    TERMINAL: 6,
    TAB: 7
  },
  ORDER_STATUS: {
    RECEIVED: 1,
    IN_PROGRESS: 2,
    READY: 3,
    DELIVERED: 4,
    TAB: 5
  },
  DAYS_OF_WEEK: [
    {value: 7, name: 'Sunday', id: 'SUN'},
    {value: 1, name: 'Monday', id: 'MON'},
    {value: 2, name: 'Tuesday', id: 'TUE'},
    {value: 3, name: 'Wednesday', id: 'WED'},
    {value: 4, name: 'Thursday', id: 'THU'},
    {value: 5, name: 'Friday', id: 'FRI'},
    {value: 6, name: 'Saturday', id: 'SAT'},
  ],
  STATUS: {
    NONE: -1,
    ACTIVE: 1,
    INACTIVE: 2,
  },
  PERK_TYPE: {
    NONE: -1,
    PRODUCT: 1,
    DISCOUNT: 2,
    CREDIT: 3
  },
  PERK_RECURRENCE_TYPE: {
    NONE: -1,
    INITIAL: 1,
    RECURRING: 2
  },
  FAMILY_MEMBER_TYPE: {
    NONE: -1,
    CHILD: 1,
    PARENT: 2,
    CAREGIVER: 3,
    OTHER: 4
  },
  RESERVATION_STATUS: {
    NONE: -1,
    RESERVED: 1,
    CONFIRMED: 2,
    WAIT_LIST: 3,
    CHECKED_IN: 4,
    ARCHIVED: 5,
    CANCELLED: 6,
    EVENT_CANCELLED: 7,
    WALKIN_WAIVER: 8,
    WALKIN_CONVERTED: 9,
    NO_SHOW: 10
  },
  WAITLIST_STATUS: {
    NONE: -1,
    PENDING: 1,
    ACTIVE: 2,
    INACTIVE: 3
  },
  CHIP_COLORS: ['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning'],
  STATUSES: [
    {id: 1, name: 'Published'},
    {id: 2, name: 'Unpublished'},
    {id: 3, name: 'Internal Use'},
    {id: 4, name: 'Archived'}
  ],
  INVENTORY_STATUS_TYPES: {
    PUBLISHED : 1,
    UNPUBLISHED: 2,
    INTERNAL_USE: 3,
    ARCHIVED: 4
  },
  STATUS_TYPES: [
    {id: 1, name: 'Active'},
    {id: 2, name: 'Archived'}
  ]

};